import { getAuth, getIdToken } from "firebase/auth";

import { getAccessToken as getOidcAccessToken } from "../auth/userManager";

/**
 * Retrieves a Firebase ID token for the current user.
 *
 * Returns null instead of propagating errors to allow getCurrentToken() to
 * fall back to other token providers (e.g., OIDC). Errors are logged for
 * debugging but don't prevent trying alternative authentication methods.
 */
const getFirebaseToken = async (): Promise<string | null> => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      return await getIdToken(user);
    }
    return null;
  } catch (error) {
    return null;
  }
};

const tokenProviders = [getFirebaseToken, getOidcAccessToken];

export const getCurrentToken = async (): Promise<string | null> => {
  try {
    for (const provider of tokenProviders) {
      const token = await provider();
      if (token) {
        return token;
      }
    }
    return null;
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};
